import { action, observable } from 'mobx';

import { PROMO_CODES } from '../constants/promoCodes';


class CampaignStore {

  @observable currentCampaign = {};
  @observable campaignToShowOnHomePage = {};
  @observable allActiveCampaigns = [];

  getCampaignCheckoutUrl = (campaign) => {
    if (campaign?.affiliateCode === PROMO_CODES.CYBERMONDAY23) {

      return '/account/purchase?_anchor=241&_shortUrl=live';
    }

    return '/account/purchase';
  };

  getHomePageCampaignForUser = (user, allActiveCampaigns) => {
    const campaign = allActiveCampaigns?.find((campaign) => campaign?.affiliateCode === PROMO_CODES.XMAS23);

    if (user?.features?.includes(campaign?.affiliateCode)) {
      campaign.checkoutUrl = this.getCampaignCheckoutUrl(campaign);

      return campaign;
    }

    return {};
  };

  findCampaignByCode = (affiliateCode) => this.allActiveCampaigns?.find((c) => c.affiliateCode === affiliateCode);

  setCampaignByPage = (currentPathName, anchorToSubscribe) => {
    if (currentPathName.includes('/account/purchase') && !anchorToSubscribe) {
      this.currentCampaign = this.findCampaignByCode(PROMO_CODES.XMAS23) || {};
    }

    if (currentPathName.includes('_anchor=241&_shortUrl=live')) {
      this.currentCampaign = this.findCampaignByCode(PROMO_CODES.CYBERMONDAY23) || {};
    }

    if (currentPathName.includes('/lifetime-promo-live')) {
      this.currentCampaign = this.allActiveCampaigns?.find((c) => c.affiliateCode?.includes('NNLIVEMRSK')) || {};
    }

    if (currentPathName === '/promo/asn-awards') {
      this.currentCampaign = this.findCampaignByCode(PROMO_CODES.ASNAW22) || {};
    }
  };

  @action setCurrentCampaign = (user, allActiveCampaigns) => {
    this.campaignToShowOnHomePage = this.getHomePageCampaignForUser(user, allActiveCampaigns);
    this.allActiveCampaigns = allActiveCampaigns;
  };
}

export default new CampaignStore();
